var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("div", { staticClass: "modal-mask", on: { click: _vm.closeModal } }, [
        _c(
          "div",
          {
            staticClass: "modal-container",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", {}),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c(
                  "h5",
                  {
                    ref: "modalTitle",
                    staticClass: "modal-title",
                    staticStyle: {
                      "border-bottom": "1px solid #C8C7C8",
                      "padding-bottom": "5px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.taskListTitle))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "task_count" }, [
                  _vm._v(_vm._s(_vm.remainingCount + " Tasks Remaining"))
                ]),
                _vm._v(" "),
                _vm._l(_vm.remainingTasks, function(remainingTask, rindex) {
                  return _c(
                    "div",
                    { key: rindex, staticClass: "row subtask-wrapper bg-grey" },
                    [
                      _c("div", { staticClass: "col-12 parent-heading" }, [
                        _vm._v(
                          " \n                      " +
                            _vm._s(remainingTask.parent_heading) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(remainingTask.headings, function(heading, hindex) {
                        return _c(
                          "div",
                          { key: hindex, staticClass: "col-12" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "heading_name",
                                staticStyle: {
                                  "border-bottom": "1px solid #C8C7C8"
                                }
                              },
                              [_vm._v(_vm._s(heading.heading_name))]
                            ),
                            _vm._v(" "),
                            _vm._l(heading.tasks, function(task, tindex) {
                              return _c("div", { key: tindex }, [
                                _c("div", { staticClass: "remaining-task" }, [
                                  _vm._v(_vm._s(task.description))
                                ])
                              ])
                            })
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                })
              ],
              2
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-432658f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432658f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/overview_remaining_tasks.vue
// module id = null
// module chunks = 